import React, { createContext, useContext, useState } from 'react';

type ModalContextValue = {
  isPtwDetailModalOpen: boolean;
  setIsPtwDetailModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedApprovalType: string | null;
  setSelectedApprovalType: React.Dispatch<React.SetStateAction<string | null>>;
  autoOpenSignatureType: string | null;
  setAutoOpenSignatureType: React.Dispatch<React.SetStateAction<string | null>>;
};

const ModalContext = createContext<ModalContextValue | undefined>(undefined);

export function PtwDetailModalProvider({ children }: { children: React.ReactNode }) {
  const [isPtwDetailModalOpen, setIsPtwDetailModalOpen] = useState(false);
  const [selectedApprovalType, setSelectedApprovalType] = useState<string | null>(null);
  const [autoOpenSignatureType, setAutoOpenSignatureType] = useState<string | null>(null);

  return React.createElement(
    ModalContext.Provider,
    {
      value: {
        isPtwDetailModalOpen,
        setIsPtwDetailModalOpen,
        selectedApprovalType,
        setSelectedApprovalType,
        autoOpenSignatureType,
        setAutoOpenSignatureType
      }
    },
    children
  );
}

export function usePtwDetailModal() {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error('usePtwDetailModal must be used within PtwDetailModalProvider');
  return ctx;
}
